export const appConfig = {
  header_navbar_bg_color: '#0099bc',
  header_navbar_text_color: '#fff',
  grid_header_footer_bg_color: '#EEF6F7',
  grid_header_footer_text_color: '#000000',
  grid_highlight_row_bg_color: '#C1C1C1',
  sidenav_default_open: true
};
